import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';

function ExportCsv({ exportRows, fileName }) {
    const [isLoading, setIsLoading] = useState(false);

    function convertArrayOfObjectsToCSV(array) {
        const columnDelimiter = ',';
        const lineDelimiter = '\n';
        const keys = Object.keys(array[0]);

        let result = '';
        result += keys.join(columnDelimiter) + lineDelimiter;

        array.forEach(item => {
            let row = keys.map(key => {
                let value = item[key] ? item[key].toString() : '';
                return `"${value.replace(/"/g, '""')}"`; // Wrap in quotes and escape quotes
            }).join(columnDelimiter);

            result += row + lineDelimiter;
        });

        return result;
    }

    function downloadCSV(array) {
        setIsLoading(true);

        setTimeout(() => {
            const link = document.createElement('a');
            let csv = convertArrayOfObjectsToCSV(array);
            if (csv == null) return;
            const filename = `${fileName}-export.csv`;
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);

            link.href = url;
            link.setAttribute('download', filename);
            link.click();

            setIsLoading(false);
        }, 1000);
    }

    return (
        <>
            <Button
                className={"btn btn-green-theme h40 w-100 mb-1 mb-sm-3 mb-3"}
                onClick={() => downloadCSV(exportRows)}
                disabled={isLoading}
            >
                {isLoading ? (
                    <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        &nbsp; Exporting...
                    </>
                ) : (
                    'Export CSV'
                )}
            </Button>
        </>
    );
}

export default ExportCsv;
